import { render } from "./myProfileBuilder.vue?vue&type=template&id=b95d1ac6&scoped=true"
import script from "./myProfileBuilder.vue?vue&type=script&lang=js"
export * from "./myProfileBuilder.vue?vue&type=script&lang=js"

import "./myProfileBuilder.vue?vue&type=style&index=0&id=b95d1ac6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95d1ac6"]])

export default __exports__